const config = {
  prefix: 'village',
  namespace: 'village',
  version: '0.0.3'
};

export default config;
